export interface IProgressLog {
  id?: string;
  name?: string;
  startDate?: Date;
  endDate?: Date;
  note?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IProgressLog> = {
  IsDeleted: false,
};
